import useSponsors from '@/hooks/useSponsors';
import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Typography } from '@mui/material';
import { useScopedField } from '@ngt/forms-core';
import { FC, useEffect, useMemo } from 'react';

const valueSubscription = {
    value: true
};

const SponsorLevel: FC = () => {
    const {
        state: {
            value: sponsorId
        }
    } = useScopedField<boolean>('sponsorId', valueSubscription);

    const {
        context: {
            setValue: setFreeSponsorRegistration
        }
    } = useScopedField<boolean>('freeSponsorRegistration', valueSubscription);

    const { sponsors } = useSponsors();

    const hasFreeRego = useMemo(() => {
        const freeRego = sponsors?.find(s => s.id == sponsorId)?.freeRegistrations;
        const regoUsed = sponsors?.find(s => s.id == sponsorId)?.registrationsUsed;

        if (freeRego) {
            if (regoUsed) {
                return regoUsed < freeRego;
            }
            else if (freeRego > 0) {
                return true;
            }
        }
        return false;
    }, [sponsors, sponsorId]);

    useEffect(() => {
        setFreeSponsorRegistration(hasFreeRego);
    }, [hasFreeRego, setFreeSponsorRegistration]);

    return (
        <Typography
            sx={{
                marginTop: "20px",
            }}
        >
            {
                hasFreeRego ?
                    <Alert
                        severity="info"
                        icon={<FontAwesomeIcon fixedWidth icon={faExclamationCircle} />}
                    >
                        There are complimentary registrations left!
                    </Alert>
                    :
                    <Alert
                        severity="info"
                        icon={<FontAwesomeIcon fixedWidth icon={faExclamationCircle} />}
                    >
                        All complimentary registrations for this sponsor have been used! You will be charged the full amount to attend the event.
                    </Alert>
            }
        </Typography>
    );
}

export default SponsorLevel;
